import { Directive, ElementRef, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';
import { combineLatest, Subject } from 'rxjs';
import { distinctUntilChanged, map, takeUntil } from 'rxjs/operators';
import { INVALID_CLASS_NAME } from '../validation.helpers';

@Directive({
  /**
   * @todo Add support of [formControl]
   */
  selector: '[appValidationClass][formControlName]'
})
export class ValidationClassDirective implements OnInit, OnDestroy {
  @Input()
  public appValidationClass?: string;

  private readonly control: NgControl;
  private readonly elementRef: ElementRef<HTMLElement>;
  private readonly destroyed$: Subject<void> = new Subject<void>();

  constructor() {
    this.control = inject(NgControl);
    this.elementRef = inject(ElementRef<HTMLElement>);
  }

  public get validationClass(): string {
    return this.appValidationClass || INVALID_CLASS_NAME;
  }

  public ngOnInit(): void {
    this.applyClass(this.control.status, !!this.control.dirty);
    if (this.control.valueChanges && this.control.statusChanges) {
      const uniqueIsDirty$ = this.control.valueChanges
        .pipe(
          map(() => this.control.dirty),
          distinctUntilChanged(),
        );

      combineLatest([
        this.control.statusChanges,
        uniqueIsDirty$,
      ])
        .pipe(takeUntil(this.destroyed$))
        .subscribe(([status, isDirty]) => {
          this.applyClass(status, !!isDirty);
        });
    }
  }

  public ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  private applyClass(status: string | null, isDirty: boolean): void {
    if (!isDirty) {
      return;
    }

    if (status === 'INVALID') {
      this.elementRef.nativeElement.classList.add(this.validationClass);
    } else {
      this.elementRef.nativeElement.classList.remove(this.validationClass);
    }
  }
}
